/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayerRewardWithOrigin } from './PlayerRewardWithOrigin';
import {
    PlayerRewardWithOriginFromJSON,
    PlayerRewardWithOriginFromJSONTyped,
    PlayerRewardWithOriginToJSON,
} from './PlayerRewardWithOrigin';

/**
 * 
 * @export
 * @interface PlayerRewardsPage
 */
export interface PlayerRewardsPage {
    /**
     * 
     * @type {Array<PlayerRewardWithOrigin>}
     * @memberof PlayerRewardsPage
     */
    rewards: Array<PlayerRewardWithOrigin>;
    /**
     * 
     * @type {number}
     * @memberof PlayerRewardsPage
     */
    totalResults: number;
    /**
     * 
     * @type {number}
     * @memberof PlayerRewardsPage
     */
    resultEnd: number;
    /**
     * 
     * @type {number}
     * @memberof PlayerRewardsPage
     */
    resultStart: number;
    /**
     * 
     * @type {string}
     * @memberof PlayerRewardsPage
     */
    playerLookupId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof PlayerRewardsPage
     */
    playerId: string;
}

/**
 * Check if a given object implements the PlayerRewardsPage interface.
 */
export function instanceOfPlayerRewardsPage(value: object): value is PlayerRewardsPage {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('resultEnd' in value) || value['resultEnd'] === undefined) return false;
    if (!('resultStart' in value) || value['resultStart'] === undefined) return false;
    if (!('playerLookupId' in value) || value['playerLookupId'] === undefined) return false;
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    return true;
}

export function PlayerRewardsPageFromJSON(json: any): PlayerRewardsPage {
    return PlayerRewardsPageFromJSONTyped(json, false);
}

export function PlayerRewardsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerRewardsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(PlayerRewardWithOriginFromJSON)),
        'totalResults': json['totalResults'],
        'resultEnd': json['resultEnd'],
        'resultStart': json['resultStart'],
        'playerLookupId': json['playerLookupId'],
        'playerId': json['playerId'],
    };
}

export function PlayerRewardsPageToJSON(value?: PlayerRewardsPage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(PlayerRewardWithOriginToJSON)),
        'totalResults': value['totalResults'],
        'resultEnd': value['resultEnd'],
        'resultStart': value['resultStart'],
        'playerLookupId': value['playerLookupId'],
        'playerId': value['playerId'],
    };
}

